import { ButtonProps } from '@chakra-ui/react';
import { RefetchOptions } from '@tanstack/react-query';
import { useState } from 'react';
import { MdRefresh } from 'react-icons/md';
import { MTooltip } from './MTooltip';
import MCustomIconButton from './MCustomIconButton';

interface RefreshTableButtonProps extends ButtonProps {
  isDisabled?: boolean;
  tooltipLabel?: string;
  refetch: (options?: RefetchOptions) => Promise<unknown>;
}

export const RefreshTableButton = ({
  refetch,
  tooltipLabel = 'Reload',
  isDisabled,
  ...rest
}: RefreshTableButtonProps) => {
  const [isLoading, setIsLoading] = useState(false);

  function handleRefresh() {
    setIsLoading(true);
    refetch({ throwOnError: false }).finally(() => setIsLoading(false));
  }

  return (
    <MTooltip label={tooltipLabel} placement="bottom-end">
      <MCustomIconButton
        variant="icon"
        containerSize="8"
        btnSize={6}
        fontSize="lg"
        cursor="pointer"
        icon={MdRefresh}
        aria-label={tooltipLabel}
        isDisabled={isDisabled || isLoading}
        isLoading={isLoading}
        {...rest}
        onClick={handleRefresh}
      />
    </MTooltip>
  );
};
